import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "top-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "user-name"
}
const _hoisted_4 = { class: "menu-content" }
const _hoisted_5 = { class: "up-container" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "bp-icon-Catalog notification" }
const _hoisted_8 = {
  key: 0,
  class: "notification-badge"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "bp-icon-Bids notification" }
const _hoisted_11 = {
  key: 0,
  class: "notification-badge"
}
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "bp-icon-Orders notification" }
const _hoisted_14 = {
  key: 0,
  class: "notification-badge"
}
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { key: 4 }
const _hoisted_17 = { key: 5 }
const _hoisted_18 = { class: "down-container" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["src"]
const _hoisted_22 = {
  key: 1,
  class: "header__mobile"
}
const _hoisted_23 = ["src"]
const _hoisted_24 = {
  key: 0,
  class: "user-name"
}
const _hoisted_25 = { class: "up-container" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "bp-icon-Catalog notification" }
const _hoisted_28 = {
  key: 0,
  class: "notification-badge"
}
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "bp-icon-Bids notification" }
const _hoisted_31 = {
  key: 0,
  class: "notification-badge"
}
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { class: "bp-icon-Orders notification" }
const _hoisted_34 = {
  key: 0,
  class: "notification-badge"
}
const _hoisted_35 = { key: 3 }
const _hoisted_36 = { key: 4 }
const _hoisted_37 = { key: 5 }
const _hoisted_38 = { class: "down-container" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }

import {ref, onMounted, onBeforeUnmount, onBeforeMount, computed, watch} from 'vue';
import anagramaImage from '@/assets/images/BeePallet_Anagrama.svg';
import logoImage from '@/assets/images/BeePallet_Logo.svg';
import toggleMenuImg from '@/assets/images/Icons/Icon_toggle-menu.svg';
import iconPlus from '@/assets/images/Icons/Icon_Plus.svg';
import { useRouter, useRoute } from 'vue-router';
import * as Session from "supertokens-web-js/recipe/session";
import {LocalStorageService} from "@/services/backend/LocalStorageService";
import { isMobile, isTablet } from '@/helpers/CommonHelper';
import { showExceptionAlert, showWarningAlertWithConfirmation } from '@/helpers/SweetAlertHelper';
import { useStore } from 'vuex'



export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  emits: ['expanded'],
  setup(__props, { emit: __emit }) {

const store = useStore()
const emit = __emit;

const showMobileMenu = ref(false);
const isExpanded = ref(true);

// 🧠 replace with Vuex state
const isLoggedIn = computed(() => store.state.isUserLoggedIn)
const userName = computed(() => store.state.profile?.name ?? '')


const totalListingNotifications = computed(() => store.state.notifications.totalListingNotifications);
const totalBidNotifcations = computed(() => store.state.notifications.totalBidNotifications);
const totalOrderMessageNotifcations = computed(() => store.state.notifications.totalOrderMessageNotifications);

const fetchNotifications = () => {
	store.dispatch('notifications/fetchNotificationCounts');
};

const router = useRouter();
const route = useRoute();

const images = {
	anagramaImage,
	logoImage,
	toggleMenuImg,
	iconPlus,
};

const handleResize = () => {
	let size = window.innerWidth;
	isMobile.value = size <= 768;
	isTablet.value = size <=1024 && size > 768;
};

const toggleSidebar = () => {
	isExpanded.value = !isExpanded.value;
	emit('expanded', isExpanded.value);
};

const toggleMenu = () => {
	showMobileMenu.value = !showMobileMenu.value;
};

const goToPage = (routeName: string) => {
	router.push({ name: routeName })
	if(isMobile) toggleMenu();
};

const logout = async () => {
	try {
		showWarningAlertWithConfirmation(
			'Cerrar sesión',
			'¿Estás seguro de que quieres salir?',
			async () => {
				await Session.signOut();
				store.commit('resetStore');
				LocalStorageService.clearAll();
				window.location.reload();
			}),
			'Salir';
	}
	catch (error) {
		showExceptionAlert(error);
	}
};



onMounted(async () => {
	handleResize();
	window.addEventListener('resize', handleResize);
});

let pollInterval: number | null = null;

onBeforeMount(async () => {
	if (isLoggedIn.value) {
		fetchNotifications();
	}
});

watch(() => isLoggedIn.value, (isLoggedIn) => {
	if (isLoggedIn) {
		fetchNotifications();
		pollInterval = setInterval(fetchNotifications, 30000);
	} else if (pollInterval) {
		clearInterval(pollInterval);
		pollInterval = null;
	}
});


onBeforeUnmount(() => {
	if (pollInterval) {
		clearInterval(pollInterval);
	}
	window.removeEventListener('resize', handleResize);
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (!_unref(isMobile))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['header', { expanded: isExpanded.value }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "logo",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (goToPage('home')))
          }, [
            _createElementVNode("img", {
              src: !isExpanded.value ? images.anagramaImage : images.logoImage,
              alt: "Logo de BeePallet"
            }, null, 8, _hoisted_2)
          ]),
          (isLoggedIn.value && userName.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                _cache[11] || (_cache[11] = _createTextVNode("Hola, ")),
                _createElementVNode("span", null, _toDisplayString(userName.value), 1)
              ]))
            : _createCommentVNode("", true),
          (isLoggedIn.value && userName.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "menu-btn add-btn btn-outline btn-outline_green",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (goToPage('create')))
              }, _cache[12] || (_cache[12] = [
                _createElementVNode("i", { class: "bp-icon-Plus" }, null, -1),
                _createElementVNode("span", null, "crear anuncio", -1)
              ])))
            : _createCommentVNode("", true),
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  to: {name: 'home'},
                  class: _normalizeClass(["menu-btn", { active: _unref(route).name === 'home'}])
                }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createElementVNode("i", { class: "bp-icon-Store" }, null, -1),
                    _createElementVNode("span", null, "Mercado", -1)
                  ])),
                  _: 1
                }, 8, ["class"])
              ]),
              (isLoggedIn.value && userName.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                    _createVNode(_component_RouterLink, {
                      to: {name: 'my_listings'},
                      class: _normalizeClass(["menu-btn", { active: _unref(route).name === 'my_listings'}])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("i", _hoisted_7, [
                          (totalListingNotifications.value > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(totalListingNotifications.value), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _cache[14] || (_cache[14] = _createElementVNode("span", null, "Mis anuncios", -1))
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]))
                : _createCommentVNode("", true),
              (isLoggedIn.value && userName.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                    _createVNode(_component_RouterLink, {
                      to: {name: 'bids'},
                      class: _normalizeClass(["menu-btn", { active: _unref(route).name === 'bids'}])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("i", _hoisted_10, [
                          (totalBidNotifcations.value > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(totalBidNotifcations.value), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _cache[15] || (_cache[15] = _createElementVNode("span", null, "Mis pujas", -1))
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]))
                : _createCommentVNode("", true),
              (isLoggedIn.value && userName.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                    _createVNode(_component_RouterLink, {
                      to: {name: 'order_list'},
                      class: _normalizeClass(["menu-btn", { active: _unref(route).name === 'order_list'}])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("i", _hoisted_13, [
                          (totalOrderMessageNotifcations.value > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(totalOrderMessageNotifcations.value), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _cache[16] || (_cache[16] = _createElementVNode("span", null, "Pedidos", -1))
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]))
                : _createCommentVNode("", true),
              (isLoggedIn.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                    _createVNode(_component_RouterLink, {
                      to: {name: 'customer_profile'},
                      class: _normalizeClass(["menu-btn", { active: _unref(route).name === 'customer_profile'}])
                    }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createElementVNode("i", { class: "bp-icon-User" }, null, -1),
                        _createElementVNode("span", null, "Mi cuenta", -1)
                      ])),
                      _: 1
                    }, 8, ["class"])
                  ]))
                : _createCommentVNode("", true),
              (isLoggedIn.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                    _createElementVNode("button", {
                      class: "menu-btn",
                      onClick: logout
                    }, _cache[18] || (_cache[18] = [
                      _createElementVNode("i", { class: "bp-icon-Log-out" }, null, -1),
                      _createElementVNode("span", null, "Cerrar sesión", -1)
                    ]))
                  ]))
                : _createCommentVNode("", true),
              (!isLoggedIn.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                    _createVNode(_component_RouterLink, {
                      to: {name: 'login'},
                      class: "menu-btn"
                    }, {
                      default: _withCtx(() => _cache[19] || (_cache[19] = [
                        _createElementVNode("i", { class: "bp-icon-User" }, null, -1),
                        _createElementVNode("span", null, "Iniciar sesión", -1)
                      ])),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[22] || (_cache[22] = _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "https://beepallet.com/blog/faq-preguntas-frecuentes/",
                  class: "menu-btn",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, [
                  _createElementVNode("i", { class: "bp-icon-FAQ" }),
                  _createElementVNode("span", null, "Preguntas frecuentes")
                ])
              ], -1)),
              (!isLoggedIn.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_19, _cache[20] || (_cache[20] = [
                    _createElementVNode("a", {
                      href: "https://beepallet.com/blog/sobre-nosotros/",
                      class: "menu-btn",
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, [
                      _createElementVNode("i", { class: "bp-icon-About-us" }),
                      _createElementVNode("span", null, "Sobre nosotros")
                    ], -1)
                  ])))
                : _createCommentVNode("", true),
              (!isLoggedIn.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_20, _cache[21] || (_cache[21] = [
                    _createElementVNode("a", {
                      href: "https://beepallet.com/blog/contacto/",
                      class: "menu-btn",
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, [
                      _createElementVNode("i", { class: "bp-icon-Contact" }),
                      _createElementVNode("span", null, "Contáctanos")
                    ], -1)
                  ])))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("button", {
          class: "toggle-button",
          onClick: toggleSidebar
        }, [
          _createElementVNode("img", {
            src: images.toggleMenuImg,
            alt: "Icono doble chevron"
          }, null, 8, _hoisted_21)
        ])
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_22, [
        _createElementVNode("button", {
          class: _normalizeClass(['menu-btn bp-icon-Burger', { hidden: showMobileMenu.value }]),
          onClick: toggleMenu
        }, null, 2),
        _createVNode(_component_RouterLink, {
          to: {name: 'home'},
          class: "header__logo"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: images.logoImage,
              alt: "Logo BeePallet"
            }, null, 8, _hoisted_23)
          ]),
          _: 1
        }),
        (!showMobileMenu.value && isLoggedIn.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "menu-btn add-btn-header btn-outline btn-outline_green bp-icon-Plus",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (goToPage('create')))
            }))
          : (showMobileMenu.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "menu-btn bp-icon-Cross",
                onClick: toggleMenu
              }))
            : (!showMobileMenu.value && !isLoggedIn.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "menu-btn add-btn-header btn-outline btn-outline_green bp-icon-User",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (goToPage('login')))
                }))
              : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(['header__mobile-menu', {show: showMobileMenu.value}])
        }, [
          (isLoggedIn.value && userName.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                _cache[23] || (_cache[23] = _createTextVNode("Hola, ")),
                _createElementVNode("span", null, _toDisplayString(userName.value), 1)
              ]))
            : _createCommentVNode("", true),
          (isLoggedIn.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "menu-btn add-btn btn-outline btn-outline_green",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (goToPage('create')))
              }, _cache[24] || (_cache[24] = [
                _createElementVNode("i", { class: "bp-icon-Plus" }, null, -1),
                _createElementVNode("span", null, "crear anuncio", -1)
              ])))
            : _createCommentVNode("", true),
          _createElementVNode("ul", {
            class: _normalizeClass(["menu-content", {'logged': isLoggedIn.value}])
          }, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (goToPage('home'))),
                  class: _normalizeClass(["menu-btn", { active: _unref(route).name === 'home'}])
                }, _cache[25] || (_cache[25] = [
                  _createElementVNode("i", { class: "bp-icon-Store" }, null, -1),
                  _createElementVNode("span", null, "Mercado", -1)
                ]), 2)
              ]),
              (isLoggedIn.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                    _createElementVNode("button", {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (goToPage('my_listings'))),
                      class: _normalizeClass(["menu-btn", { active: _unref(route).name === 'my_listings'}])
                    }, [
                      _createElementVNode("i", _hoisted_27, [
                        (totalListingNotifications.value > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(totalListingNotifications.value), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _cache[26] || (_cache[26] = _createElementVNode("span", null, "Mis anuncios", -1))
                    ], 2)
                  ]))
                : _createCommentVNode("", true),
              (isLoggedIn.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                    _createElementVNode("button", {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (goToPage('bids'))),
                      class: _normalizeClass(["menu-btn", { active: _unref(route).name === 'bids'}])
                    }, [
                      _createElementVNode("i", _hoisted_30, [
                        (totalBidNotifcations.value > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(totalBidNotifcations.value), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _cache[27] || (_cache[27] = _createElementVNode("span", null, "Mis pujas", -1))
                    ], 2)
                  ]))
                : _createCommentVNode("", true),
              (isLoggedIn.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                    _createElementVNode("button", {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (goToPage('order_list'))),
                      class: _normalizeClass(["menu-btn", { active: _unref(route).name === 'order_list'}])
                    }, [
                      _createElementVNode("i", _hoisted_33, [
                        (totalOrderMessageNotifcations.value > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(totalOrderMessageNotifcations.value), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _cache[28] || (_cache[28] = _createElementVNode("span", null, "Pedidos", -1))
                    ], 2)
                  ]))
                : _createCommentVNode("", true),
              (isLoggedIn.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
                    _createElementVNode("button", {
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (goToPage('customer_profile'))),
                      class: _normalizeClass(["menu-btn", { active: _unref(route).name === 'customer_profile'}])
                    }, _cache[29] || (_cache[29] = [
                      _createElementVNode("i", { class: "bp-icon-User" }, null, -1),
                      _createElementVNode("span", null, "Mi cuenta", -1)
                    ]), 2)
                  ]))
                : _createCommentVNode("", true),
              (isLoggedIn.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_36, [
                    _createElementVNode("button", {
                      class: "menu-btn",
                      onClick: logout
                    }, _cache[30] || (_cache[30] = [
                      _createElementVNode("i", { class: "bp-icon-Log-out" }, null, -1),
                      _createElementVNode("span", null, "Cerrar sesión", -1)
                    ]))
                  ]))
                : _createCommentVNode("", true),
              (!isLoggedIn.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_37, [
                    _createElementVNode("button", {
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (goToPage('login'))),
                      class: "menu-btn"
                    }, _cache[31] || (_cache[31] = [
                      _createElementVNode("i", { class: "bp-icon-User" }, null, -1),
                      _createElementVNode("span", null, "Iniciar sesión", -1)
                    ]))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _cache[34] || (_cache[34] = _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "https://beepallet.com/blog/faq-preguntas-frecuentes/",
                  class: "menu-btn",
                  target: "_blank",
                  rel: "noopener"
                }, [
                  _createElementVNode("i", { class: "bp-icon-FAQ" }),
                  _createElementVNode("span", null, "Preguntas frecuentes")
                ])
              ], -1)),
              (!isLoggedIn.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_39, _cache[32] || (_cache[32] = [
                    _createElementVNode("a", {
                      href: "https://beepallet.com/blog/sobre-nosotros/",
                      class: "menu-btn",
                      target: "_blank",
                      rel: "noopener"
                    }, [
                      _createElementVNode("i", { class: "bp-icon-About-us" }),
                      _createElementVNode("span", null, "Sobre nosotros")
                    ], -1)
                  ])))
                : _createCommentVNode("", true),
              (!isLoggedIn.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_40, _cache[33] || (_cache[33] = [
                    _createElementVNode("a", {
                      href: "https://beepallet.com/blog/contacto/",
                      class: "menu-btn",
                      target: "_blank",
                      rel: "noopener"
                    }, [
                      _createElementVNode("i", { class: "bp-icon-Contact" }),
                      _createElementVNode("span", null, "Contáctanos")
                    ], -1)
                  ])))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ], 2)
      ]))
}
}

})